import React, { useEffect, useState } from 'react';
import { Route, Link } from "react-router-dom";
import { Layout, Menu } from "antd";
import Nav from "../../components/Nav";
import { getUser } from "../../api/nav";
import { getQueryString } from '../../utils/tools';
import { Survey, Setting } from './containers';
import './style.less';

const { Sider, Content } = Layout;
const siteId = getQueryString('site_id');
const clsPrefix = "p-multi-domain";

interface MultiDomain {
  match: {
    url: string
  }
}

const getSelectedKeyByRoute = () => {
  let currentRoute = window.location.pathname;

  let selectedKey = null;
  switch (currentRoute) {
    case `/v5/multi-domain`:
      selectedKey = ["0"];
      break;

    case `/v5/multi-domain/setting`:
      selectedKey = ["1"];
      break;

    default:
      selectedKey = ["0"];
      break;
  }
  return selectedKey;
};

const MultiDomainPage:React.FC<MultiDomain> = ({ match }) => {
  const [ userId, setUserId ] = useState<string>();
  useEffect(() => {
    getUser().then((res) => {
      setUserId(res.data.user_id)
    })
  }, [])
  return (
    <>
      <Nav />
      <Layout style={{ maxHeight: "0" }}>
        <Sider className={`${clsPrefix}__sider`} theme="light">
          <Menu
            theme='light'
            mode='inline'
            defaultSelectedKeys={getSelectedKeyByRoute()}
          >
            <Menu.Item key="0">
              <Link 
                to={{
                  pathname: "/v5/multi-domain",
                  search: `?site_id=${siteId}`
                }}
              >
                概况
              </Link>
            </Menu.Item>
            <Menu.Item key="1">
              <Link 
                to={{
                  pathname: "/v5/multi-domain/setting",
                  search: `?site_id=${siteId}`
                }}
              >
                设置
              </Link>
            </Menu.Item>
          </Menu>
        </Sider>
        <Content className={`${clsPrefix}__content`}>
          <Route exact path={`${match.url}`} component={() => <Survey userId={userId} />} />
          <Route path={`${match.url}/setting`} component={() => <Setting userId={userId} />} />
        </Content>
      </Layout>
    </>
  )
}
export default MultiDomainPage;